export default __webpack_public_path__ + "static/media/Scholar's Hood of Twining Smoke.23adb53e.jpg";